export const SECONDS_IN_DAY = 86400;
export const HOURS_IN_DAY = 24;
export const SECONDS_IN_HOUR = 3600;
export const MINUTES_IN_HOUR = 60;
export const SECONDS_IN_MINUTE = 60;
